export enum KFZ_CHOICE {
  WKZ = 'wkz',
  ALL_WKZS = 'allWkzs',
  NUTZUNGSART = 'nutzungsart',
  NUTZERKREIS = 'nutzerkreis',
  SF_KLASSE_KH = 'sfKlasseKH',
  SF_KLASSE_VK = 'sfKlasseVK',
  KFZ_DECKUNGSSUMME = 'kfzDeckungssumme',
  FINANZIERUNGSART = 'finanzierungsart',
  MONTHS = 'monate',
  KASKO_TYP = 'kaskoTyp',
  HALTER_TYP = 'halterTyp',
  KFZ_BERUFSSTATUS = 'kfzBerufsstatus',
  JOBS = 'berufe',
  JOB_SECTOR = 'branche',
  SPECIAL_EMPLOYER = 'speziellerArbeitgeber',
  KFZ_TARIFGRUPPE = 'kfzTarifgruppe',
  HOME_OWNERSHIP_TYPE = 'wohneigentumTyp',
  VERSICHERUNGSART_VERSICHERER_TARIF_WECHSEL = 'versicherungsartVersichererTarifWechsel',
  VERSICHERUNGSART_NEUES_FAHRZEUG = 'versicherungsartNeuesFahrzeug',
  MINOR_CHILDREN = 'minderjaehrigeKinder',
  DRIVE_MODE = 'antriebsart',
  PARKING_LOT = 'stellplatz',
  FOREIGN_USE = 'auslandsnutzung',
  BEZUG_ZUM_VN_PRIVAT_PERSON = 'bezugZumVnPrivatPerson',
  BEZUG_ZUM_VN_JURISTISCHE_PERSON = 'bezugZumVnJuristischePerson',
  WERKSTATTBINDUNG = 'werkstattbindung',
  TIERBISSFOLGESCHAEDEN = 'tierbissfolgeschaeden',
  KFZ_AUFBAUART = 'aufbauart',
  KFZ_GEFAHRGUT = 'gefahrgut',
  KFZ_ANHAENGER_BAUART = 'anhaengerBauart',
  HERSTELLERLISTE = 'herstellerliste',
  DACHART = 'dachart',
  KRAD_BAUART = 'kradBauart',
  VORFAHRZEUG_VERBLEIB = 'vorfahrzeugVerbleib',
  GESELLSCHAFTEN_TS = 'gesellschaftenTS',
}

/**
 * KFZ-V2-Choices (Softfair V2) als eigenes Enum, damit sie NICHT in den Eager-Preload der
 * V1-KFZ-Sparten gelangen. Nur V2-Sparten (campv2) laden diese Liste zusätzlich.
 */
export enum KFZ_V2_CHOICE {
  FOREIGN_USE_V2 = 'auslandnutzungV2',
  JAHRESKARTE_OEPNV = 'jahreskarteOepnv',
  // Softfair-V2 akzeptiert SF-Klassen bis SF 70; V1/SOAP endet bei SF 50.
  SF_KLASSE_KH_V2 = 'sfKlasseKHV2',
  SF_KLASSE_VK_V2 = 'sfKlasseVKV2',
}

export enum KFZ_META {
  MINOR_CHILDREN_HAS_MEHRERE_KINDER = 'hasMehrereKinder',
  MINOR_CHILDREN_EIN_KIND = 'einKind',
  MINOR_CHILDREN_KEIN_KIND = 'nein',

  SF_KLASSE_KH_NOT_RELEVANT_FOR_VORVERSICHERUNG = 'notRelevantForVorversicherung',

  HALTER_TYP_IN_SAME_HOUSEHOLD = 'inHaeuslicherGemeinschaftMitVN',
  HALTER_TYP_IS_FIRMA = 'isFirma',
  HALTER_TPY_IS_NATURAL_PERSON = 'isNaturalPerson',

  VERSICHERUNGSART_IS_ERSTVERTRAG_OHNE_VERSICHERUNG = 'isErstvertragOhneVorversicherung',
  VERSICHERUNGSART_NEUES_FAHRZEUG_IS_ZWEITWAGEN = 'isZweitwagen',
  VERSICHERUNGSART_NEUES_FAHRZEUG_WECHSEL = 'fahrzeugwechsel',
  VERSICHERUNGSART_NEUES_FAHRZEUG_ZULASSUNG_CHECK = 'requiresZulassungNotBeforeVersicherungsbeginn',
  VERSICHERUNGSART_TARIF_WECHSEL_EVB = 'isEvbVisible',
  VERSICHERUNGSART_TARIF_VERSICHERER_WECHSEL = 'isVersichererwechsel',
  VERSICHERUNGSART_TARIF_WIEDERINBETRIEBNAHME = 'isWiederinbetriebnahme',

  KASKO_TYP_VOLLKASKO = 'isVollkasko',
  KASKO_TYP_TEILKASKO = 'isTeilkasko',

  JOB_SECTOR_AUTOMOTIVE = 'isAutomotive',

  BEZUG_ZUM_VN_IS_EINZELNUTZER = 'isEinzelnutzer',
  BEZUG_ZUM_VN_IS_GF_HAUPTNUTZER = 'isGfInhaberHauptnutzer',

  KFZ_BERUFSSTATUS_IS_VORSTEUER_ABZUGS_BERECHTIGT = 'isVorsteuerAbzugsBerechtigt',

  NUTZUNGSART_PRIVAT = 'ausschliesslichPrivat',

  FINANZIERUNGSART_NOT_SELF_FINANCING = 'notEigenfinanzierung',

  KFZ_WKZ_WERKVERKEHR = 'werkverkehr',
  KFZ_WKZ_GEWERBLICHER_GUETERVERKEHR = 'gewerblicherGueterverkehr',
  KFZ_WKZ_SONSTIGE = 'sonstige',
  KFZ_AUFBAUART = 'hasAufbauart',
  KFZ_GESAMTGEWICHT = 'hasGesamtgewicht',
  KFZ_GEFAHRGUT = 'hasGefahrgut',
  KFZ_ASSISTENZSYSTEM = 'hasAssistenzsystem',
  KFZ_FAHRERKREIS = 'hasFahrerkreis',
  KFZ_SF_KLASSE = 'hasSfKlasse',
  KFZ_NEUWERT = 'hasNeuwert',
  KFZ_LEISTUNG = 'hasLeistung',
  KFZ_JAEHRLICHE_FAHRLEISTUNG = 'hasJaehrlicheFahrleistung',
  KFZ_KILOMETERSTAND = 'hasKilometerstand',
  KFZ_NUTZUNGSART = 'hasNutzungsart',
  KFZ_ANHAENGER_BAUART = 'hasAnhaengerBauart',
  KFZ_FAHRERSCHUTZVERSICHERUNG = 'hasFahrerschutzversicherung',
  KFZ_RABATTSCHUTZ_HAFTPFLICHT = 'hasRabattschutzKfzHaftpflicht',
  KFZ_RABATTSCHUTZ_VOLLKASKO = 'hasRabattschutzKfzVollkasko',
  KFZ_EMPTY_HERSTELLER = 'isEmptyHersteller',
  KFZ_HAS_ZEITWERT = 'hasZeitwert',
  KFZ_HAS_LEERGEWICHT = 'hasLeergewicht',
  KFZ_HAS_KRAD_BAUART = 'hasKradBauart',
  KFZ_HAS_HUBRAUM = 'hasHubraum',
  KFZ_WKZ_SELECTION_GROUPS = 'selectionGrouping',
  KFZ_WKZ_TO_SPARTE = 'wkzToSparte',
  VORFAHRZEUG_IST_ABGEMELDET_VERKAUFT = 'vorfahrzeugIstAbgemeldetVerkauft',
  KFZ_ABWEICHENDERHALTER_TYP_COMPANY = 'isCompanyTyp',
}
